import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=b68b4bc4&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Head: require('/home/bitrix/frontend/components/masterpiece/Head.vue').default,Description: require('/home/bitrix/frontend/components/masterpiece/Description.vue').default,Foot: require('/home/bitrix/frontend/components/masterpiece/Foot.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default})
